import { Component } from '@angular/core';

@Component({
  selector: 'app-go-up',
  templateUrl: './go-up.component.html',
  styleUrls: ['./go-up.component.scss']
})
export class GoUpComponent  {


  letGoTop = () => {
    let mainInter = document.getElementById('interno');
    mainInter?.scroll(0, 0);
    let main = document.getElementById('content-layout-id');
    main?.scroll(0, 0);
  }

}
